import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Navbar from '../component/Navbar';
import { useNavigate } from 'react-router-dom';

const News = () => {
    const url = window.location.origin;
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const URL_GET_PROJECT = `${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`;

    const [dataNews, setDataNews] = useState([]);
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_NEWS = "api/kejati/news";

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response;
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(URL_GET_PROJECT).then((value) => {
            setAppLogo(`${BASE_URL}upload/logo/${value.data.logo}`)
        });

        fetchData(`${BASE_URL}${PATH_NEWS}`).then((data) => {
            setDataNews(data?.data || []);
        });
    }, [domain]);


    if (loading) {
        return <div>Loading...</div>;
    }

    const overlayStyle = {
        position: 'absolute',           // Absolutely position the overlay on top of the background
        top: '150px',
        left: 0,
        right: 0,
        bottom: '150px',
        backgroundImage: `url(${appLogo})`,  // Dynamically use the appLogo as the background image
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,                   // Set opacity for transparency (0 is fully transparent, 1 is opaque)
        pointerEvents: 'none',
    };

    return (
        <div >
            <div style={overlayStyle}></div>
            <Navbar appLogo={appLogo} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />

            <div className="bg-gray-100 min-h-screen p-6">
                <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">News Portal</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {dataNews?.map((newsItem, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img
                                src={`${process.env.REACT_APP_API_URL}upload/${newsItem.image}` }
                                alt={newsItem.headline}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-4">                            
                                <a href={`/activity-kejati/news/detail/${newsItem.id}`} className="h-2 text-xl font-semibold text-gray-800 mb-2">
                                    {newsItem.headline}
                                </a>
                                <div className="text-sm text-gray-500 mb-4">
                                    <span>By: {newsItem.author}</span> | <span>Category: {newsItem.category}</span>
                                </div>
                                <p className="text-gray-600 mb-4">
                                    {newsItem.description}
                                </p>
                                {/* <p className="text-gray-700">
                                    {newsItem.article}
                                </p> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default News;